import { callCloudFunction } from './core';

export default function processChannelImage(channelKey, uploadKey, isBanner) {
  return callCloudFunction('processChannelImage', {
    channelKey,
    isBanner,
    uploadKey,
  });
}
